import { Image } from "@mantine/core";

export function ImageCore({
  src,
  fit,
  h = 200,
  w
}: {
  src: string;
  fit?: React.CSSProperties["objectFit"];
  h?: number | string;
  w?: number | string;
}) {
  return (
    <>
      <div>
        <Image
          radius="md"
          src={src}
          h={h ?? "100%"}
          w={w ?? "100%"}
          bd={"1px solid #dee2e6"}
          fit={fit ?? "contain"}
          //  fallbackSrc="https://placehold.co/600x400?text=Placeholder"
        />
      </div>
    </>
  );
}
